import { Box } from '@mui/material';
import placeholder from 'lodash/fp/placeholder';
import React, { useEffect,useState } from 'react';

import ResponseCardPlagiarism from '@/features/components/resultDisplay/ResponseCardPlagiarism';
import StreamingResponseCard from '@/features/components/resultDisplay/StreamingResponseCard';
import TabButtonGroup from '@/features/components/TabButtonGroup';
import { handleCopy, handleDelete, handlePerformance } from '@/features/Functions/ResultFunctions';

interface ResponseContainerProps {
  responses: any[];
  setResponses: React.Dispatch<React.SetStateAction<any[]>>;
  streamingResponse: string;
  isStreaming: boolean;
  premium: boolean;
  selectedTab: 'result' | 'history'; // Prop to control the selected tab
  handleTabChange: (tab: 'result' | 'history') => void; // Prop to handle tab change
  placeholderText: string;
}

const ResponseContainer: React.FC<ResponseContainerProps> = ({
                                                               responses,
                                                               setResponses,
                                                               streamingResponse,
                                                               isStreaming,
                                                               premium,
                                                               selectedTab,
                                                               placeholderText
                                                             }) => {
  const [lastResponse, setLastResponse] = useState<string>('');

  // Update lastResponse to the latest response in the history
  useEffect(() => {
    if (responses.length > 0) {
      setLastResponse(responses[0]); // The latest response is at index 0
      console.log('Last response updated:', responses[0]); // Debugging log
    }
  }, [responses]);

  // Update last response when streaming is finished
  useEffect(() => {
    if (!isStreaming && streamingResponse && streamingResponse !== lastResponse) {
      setResponses((prevResponses) => [streamingResponse, ...prevResponses]); // Add new response to the history
    }
  }, [streamingResponse, isStreaming, lastResponse, setResponses]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>


      {/* Content based on selected tab */}
      {selectedTab === 'result' && (
        (isStreaming || responses.length === 0) ? (
          <StreamingResponseCard streamingResponse={streamingResponse} placeholderText={placeholderText}/>
        ) : (
          <ResponseCardPlagiarism
            key={0} // A unique key for the response card
            response={lastResponse}
            index={0} // You can customize this value
            responses={responses}
            setResponses={setResponses}
            handleCopy={handleCopy}
            handleDelete={handleDelete}
            handlePerformance={handlePerformance}
            premium={premium}
          />
        )
      )}

      {selectedTab === 'history' && responses.length > 0 && (
        responses.map((response, index) => (
          <ResponseCardPlagiarism
            key={index}
            response={response}
            index={index}
            responses={responses}
            setResponses={setResponses}
            handleCopy={handleCopy}
            handleDelete={handleDelete}
            handlePerformance={handlePerformance}
            premium={premium}
          />
        ))
      )}
    </Box>
  );
};

export default ResponseContainer;
